import { useState, useEffect } from 'react'
import { getEmpsNameAPI } from '../services/employee'

function UseEmpsName(orgId, searchs) {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const result = await getEmpsNameAPI({
        orgId,
        searchs,
        // page: 1,
        // size: 20
      })
      if (!result) return

      const newData = result.result && result.result.map((d, i) => {
        return {
          value: d.name,
          label: `${d.name}`
        }
      })

      setData(newData)
    }
    if (orgId) {
      getData()
    }
  }, [orgId, searchs])

  return data
}

export default UseEmpsName
